export default {
  'Animate old photos': 'Анимация старых фотографий',
  'Animate faces in your photos with AI technology, create vivid videos.':
    'Анимируйте лица на своих фотографиях с помощью технологии искусственного интеллекта, создавайте яркие видео.',
  'Upload a photo': 'Загрузить фотографию',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.':
    'Примечание: пожалуйста, убедитесь, что лицо на выбранных вами фотографиях обращено к объективу, иначе оно не может быть успешно обработано.',
  'Uploaded successfully!': 'Загружено успешно!',
  'Please select a template below': 'Пожалуйста, выберите шаблон ниже',
  'Choose a GIF': 'Выберите GIF',
  'Use this template': 'Используйте этот шаблон',
  'Verify successfully! You will':
    'Проверка успешно пройдена! Вы скоро получите видео с {{email}}.',
  'You will': 'Вы скоро получите видео с {{email}}.',
  'What you should expect to happen next': 'Что Вам следует ожидать далее:',
  'We will process your photo into a dynamic video.':
    'Мы обработаем вашу фотографию в динамичное видео.',
  'After processing, we will send the video to your email.':
    'После обработки мы отправим видео на вашу электронную почту.',
  'You can check the video in your email.':
    'Вы можете проверить видео в своей электронной почте.',
  'Your video will be delivered via email':
    'Ваше видео будет доставлено по электронной почте',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.':
    'Синтез динамического видео занимает 20-30 минут, пожалуйста, наберитесь терпения. Чтобы защитить вашу частную жизнь, загруженные фотографии будут автоматически удалены после завершения обработки.',
  'Your Email': 'Ваша электронная почта',
  'Last Name': 'Имя',
  'First Name': 'Фамилия',
  'Go back': 'Вернуться',
  'Invalid email address': 'Неверный адрес электронной почты',
  'Enter verification code': 'Введите проверочный код',
  'Enter the verification code that we sent to':
    'Введите проверочный код, который мы отправили в {{email}}.',
  Resend: 'Отправить повторно',
  'Verification code': 'Код подтверждения',
  'Resend after': 'Повторная отправка через {{num}} секунд',
  'The verification code is invalid. You can request a new one.':
    'Проверочный код недействителен. Вы можете запросить новый.',
  'Synthesize Video': 'Синтезировать видео',
  Next: 'Следующий',
  'Too many attempts, please try again later.':
    'Слишком много попыток, пожалуйста, попробуйте еще раз позже.',
  'xx people is waitting in front of you to generate image.':
    ' creators ahead of you, please wait...',
  'Animating...': 'Animating...',
  'You are in line...': 'You are in line...',
  'Failed to generate, click to retry.': 'Failed to generate, click to retry.',
  'The processing will be completed soon, are you sure you want to cancel it?':
    'The processing will be completed soon, are you sure you want to cancel it?',
  freeAccountExceed: 'The image size cannot exceed 2MB in free version.',
  freeAccountHD: 'Upgrade to download HD watermark-free images.',
  UpgradeToDownloadAsGIF: 'Upgrade to download video as GIF.',
  UpgradeToUploadLimits: 'Upgrade to unlimited image uploads.',
  DynamicTitle: 'HitPaw Online Animate Old Photos',
  SizeLimit: 'No Image Size Limits',
  UploadLimit: 'Unlimited Image Uploads',
  DownloadNoWaterMark: 'Download HD Image with No Watermark',
  DownloadGIF: 'Download Video as GIF',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  priceWeek: '$3.99',
  priceMonth: '$1.99',
  priceYear: '$0.99',
  Week: 'Week',
  billMonth: '$7.99 Billed Monthly',
  billYear: '$47.99 Billed Annually',
};
